// extracted by mini-css-extract-plugin
export default {"canvas":"Anniversary_canvas"};